import { styled } from 'styled-components';

export const CalculationStatisticIcon = styled.img`
  width: 7rem;
`;
